// Device identifiers typed or pasted in the admin area → canonical form (same normaliser as ingest).
import { normalizeTagIdentifier } from '@fleetspoke/core/identifiers';

/** The fixed categories a device type belongs to (public.device_types.category): what the code acts on. */
export type DeviceCategory = 'ble_beacon' | 'ble_sensor' | 'gps_tracker' | 'fixed_gateway';
export const DEVICE_CATEGORIES: readonly DeviceCategory[] = [
  'ble_beacon',
  'ble_sensor',
  'gps_tracker',
  'fixed_gateway',
];

/** Trackers and gateways connect through Traccar (IMEI, a protocol); beacons and sensors are only heard. */
export const connectsToTraccar = (c: DeviceCategory) =>
  c === 'gps_tracker' || c === 'fixed_gateway';

/** "Teltonika EYE Beacon (BTSID1)". */
export const deviceTypeName = (dt: { manufacturer: string; model: string }) =>
  `${dt.manufacturer} ${dt.model}`;

/** One identifier per line → canonical form; IMEI categories need 15 digits. Returns [valid, invalid]. */
export function parseIdentifiers(text: string, category: DeviceCategory): [string[], string[]] {
  const ok: string[] = [];
  const bad: string[] = [];
  for (const raw of text
    .split(/[\r\n,;]+/)
    .map((s) => s.trim())
    .filter(Boolean)) {
    if (connectsToTraccar(category)) {
      if (/^\d{15}$/.test(raw)) ok.push(raw);
      else bad.push(raw);
    } else {
      const id = normalizeTagIdentifier(raw);
      if (id && /^(eddystone|ibeacon|mac):/.test(id)) ok.push(id);
      else bad.push(raw);
    }
  }
  return [[...new Set(ok)], bad];
}
